export const TERMS_URL = 'https://www.kakao.com/policy/terms#useterms03_11';
export const MANAGEMENT_POLICY_URL = 'https://t1.kakaocdn.net/zzng_static/digital-card/terms/policy.html';
export const CS_URL = 'https://cs.kakao.com/helps?service=179&category=667&locale=ko';
export const PROPOSITION_URL = 'https://with.kakao.com/wallet/proposition';
export const BIZ_COMM_URL = 'https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1208147521';
export const KAKAO_CORP_URL = 'https://www.kakaocorp.com/page';
export const PRIVACY_POLICY_URL = 'https://www.kakao.com/policy/privacy?type=p&lang=ko';
